import React from 'react';
import { useAppContext } from '../utils/AppContext';
import { localStorageManager } from '../utils/localStorage';
import './Dashboard.css';

interface ScreenCard {
  id: string;
  title: string;
  description: string;
  path: string;
  icon: string;
}

const screens: ScreenCard[] = [
  {
    id: 'timer',
    title: 'Temporizador',
    description: 'Temporizador para competiciones y eventos',
    path: '/timer',
    icon: '⏱'
  },
  {
    id: 'bracket',
    title: 'Bracket',
    description: 'Sistema de eliminatorias y torneos',
    path: '/bracket',
    icon: '🏆'
  },
  {
    id: 'leaderboard',
    title: 'Clasificación',
    description: 'Tabla de puntuaciones en tiempo real',
    path: '/leaderboard',
    icon: '📊'
  },
  {
    id: 'carousel',
    title: 'Carousel',
    description: 'Galería multimedia y presentaciones',
    path: '/carousel',
    icon: '🎬'
  },
  {
    id: 'podium',
    title: 'Podium',
    description: 'Ceremonia de premiación y ganadores',
    path: '/podium',
    icon: '🏆'
  },
  {
    id: 'pizarra',
    title: 'Pizarra',
    description: 'Pizarras de equipos con números',
    path: '/pizarra',
    icon: '📝'
  }
];

const Dashboard: React.FC = () => {
  const { openWindow } = useAppContext();

  const handleOpenScreen = (screen: ScreenCard) => {
    openWindow(screen.path, screen.title);
  };

  const openAllScreens = () => {
    screens.forEach((screen, index) => {
      setTimeout(() => {
        openWindow(screen.path, screen.title);
      }, index * 200);
    });
  };
  const resetConfiguration = () => {
    if (window.confirm('¿Estás seguro de que quieres restablecer toda la configuración?')) {
      localStorageManager.reset();
      window.location.reload();
    }
  };

  const clearAllData = () => {
    if (window.confirm('¿Estás seguro de que quieres ELIMINAR TODOS LOS DATOS? Esta acción no se puede deshacer.')) {
      localStorageManager.clearAll();
      window.location.reload();
    }
  };

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Panel de Control</h1>
        <p className="dashboard-subtitle">Gestión centralizada de pantallas</p>
        
        <div className="system-status">
          <div className="status-dot"></div>
          <span>Comunicación activa</span>
        </div>
      </div>

      <div className="dashboard-content">
        <section className="screens-section">
          <h2 className="section-title">Pantallas disponibles</h2>
          
          <div className="screens-grid">
            {screens.map((screen) => (
              <div key={screen.id} className="screen-card">
                <div className="screen-header">
                  <div className="screen-icon">{screen.icon}</div>
                </div>
                
                <div className="screen-info">
                  <h3 className="screen-title">{screen.title}</h3>
                  <p className="screen-description">{screen.description}</p>
                </div>
                  <div className="screen-controls">
                  <button 
                    className="open-screen-btn"
                    onClick={() => handleOpenScreen(screen)}
                  >
                    Abrir pantalla
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>        <section className="actions-section">
          <h2 className="section-title">Acciones rápidas</h2>
          <div className="actions-grid">
            <button 
              className="action-btn primary"
              onClick={openAllScreens}
            >
              Abrir todas las pantallas
            </button>
            <button 
              className="action-btn secondary"
              onClick={resetConfiguration}
            >
              Restablecer configuración
            </button>
            <button 
              className="action-btn danger"
              onClick={clearAllData}
            >
              🗑️ Restablecer Todo
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Dashboard;